import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

export const NavBarContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-neutral-200);
  background-color: var(--color-bg);
`

export const NavTabButton = styled.button<{ $active: boolean }>`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  padding: 0.75rem 1rem;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '600' : '500')};
  color: ${({ $active }) => ($active ? 'var(--color-accent)' : 'var(--color-neutral-200)')};
  border-bottom: 2px solid ${({ $active }) => ($active ? 'var(--color-accent)' : 'transparent')};
  margin-bottom: -1px;
  transition: color 0.15s ease, border-color 0.15s ease;

  &:hover {
    color: var(--color-text-secondary);
  }
`

export const NavTab = styled(NavLink)`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  padding: 5px 46.4px;
  font-size: 14px;
  font-weight: 500;
  color: var(--color-neutral-200);
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.15s ease, border-color 0.15s ease;

  &:hover {
    color: var(--color-text-secondary);
  }

  &.active {
    color: var(--color-accent);
    border-bottom-color: var(--color-accent);
    font-weight: 600;
  }
`
